import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { actions as locationActions } from "../location";

import LocationsList from "./LocationsList.view";

const mapStateToProps = state => ({
  locations: state.locations,
  locationsError: state.locationsError,
  locationsLoading: state.locationsLoading,
});

const mapDispatchToProps = dispatch => ({
  locationsFetch: () => dispatch(locationActions.fetch()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LocationsList)
);
